<template>
  <img
    :src="image.url"
    :srcset="srcset"
    :sizes="sizes"
    :alt="image.alt"
    :title="image.title"
    :class="css"
  >
</template>

<script>
// Data Models
import Image from '@/models/Image';

export default {
  name: 'ResponsiveImage',
  props: {
    id: {
      type: Number,
      required: true,
    },
    css: {
      type: String,
      default: '',
    },
  },
  computed: {
    image() {
      return Image.query()
        .with('sizes')
        .find(this.id);
    },
    srcset() {
      let srcset = '';
      this.image.sizes.forEach(size => {
        srcset = srcset + size.url + ' ' + size.width + 'w, ';
      });
      return srcset;
    },
    sizes() {
      let sizes = '';
      this.image.sizes.forEach(size => {
        sizes = sizes + '(max-width: ' + size.width + 'px) ' + size.width + 'px, ';
      });
      return sizes;
    },
  },
  watch: {
    image() {
      this.imageSize();
    },
  },
  mounted() {
    this.imageSize();
  },
  methods: {
    imageSize() {
      this.$emit('image-size', {
        width: this.image.width,
        height: this.image.height,
      });
    },
  },
};
</script>
